<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>INTEGRAR ITENS</span>
                </h4>
                <b-alert
                    :show="retorno !== null"
                    :variant="retorno ? retorno.variant : 'info'"
                >
                    {{ retorno ? retorno.mensagem : '' }}
                </b-alert>
                <b-row>
                    <b-col sm="12" md="6">
                        <b-form-group>
                            <label
                                >Contrato<span class="text-danger"
                                    >*</span
                                ></label
                            >
                            <model-list-select
                                :list="contratos"
                                option-text="codContratoFornecedor"
                                option-value="idContrato"
                                v-model="idContrato"
                            >
                            </model-list-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6">
                        <b-form-group>
                            <label
                                >Categoria MeEventos<span class="text-danger"
                                    >*</span
                                ></label
                            >
                            <model-list-select
                                :list="categorias"
                                option-text="nomeCategoria"
                                option-value="idCategoria"
                                v-model="idCategoria"
                            >
                            </model-list-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <div class="d-flex flex-row-reverse">
                    <b-button variant="danger" @click.stop="voltar()">
                        <i class="fa fa-history mr-2"></i>Voltar
                    </b-button>
                </div>
            </b-card-body>
        </b-card>

        <b-row v-if="idContrato">
            <b-col sm="12" md="5">
                <painel-itens
                    :itens="itens"
                    :itemEmFoco="itemEmFoco"
                    :selecao="selecaoItens"
                    @focar="focarItem($event)"
                    @alternar="alternarItem($event)"
                ></painel-itens>
            </b-col>
            <b-col sm="12" md="7">
                <painel-sub-itens
                    :item="itemEmFoco"
                    :subItens="subItensEmFoco"
                    :selecao="selecaoSubItens"
                    :selecionados="selecionados"
                    :totalSelecionados="totalSelecionados"
                    @alternar="alternarSubItem($event)"
                    @marcarNaoIntegrados="marcarNaoIntegrados($event)"
                    @remover="remover($event)"
                ></painel-sub-itens>
            </b-col>
        </b-row>

        <b-card no-body class="mt-3 barra-selecao" v-if="idContrato">
            <b-card-body class="py-2">
                <span>
                    <strong>{{ totalSelecionados }}</strong>
                    {{ totalSelecionados === 1 ? 'selecionado' : 'selecionados' }}
                    <small class="text-muted ml-2"
                        >{{ totalItensSelecionados }} item(ns),
                        {{ totalSubItensSelecionados }} subitem(ns)</small
                    >
                    <small class="text-muted ml-2" v-if="impedimento"
                        >· {{ impedimento }}</small
                    >
                </span>
                <span class="float-right">
                    <b-button
                        variant="secondary"
                        class="mr-2"
                        :disabled="totalSelecionados === 0"
                        @click.stop="limpar()"
                        >Limpar</b-button
                    >
                    <b-button
                        variant="primary"
                        :disabled="!podeIntegrar"
                        :title="impedimento"
                        @click.stop="integrar()"
                        >Integrar</b-button
                    >
                </span>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import { ModelListSelect } from 'vue-search-select'
import MeEventosServicos from './MeEventosServicos'
import PainelItens from './PainelItens.vue'
import PainelSubItens from './PainelSubItens.vue'

export default {
    components: {
        ModelListSelect,
        PainelItens,
        PainelSubItens
    },

    data() {
        return {
            retorno: null,
            temporizadorRetorno: null,
            contratos: [],
            idContrato: null,
            categorias: [],
            idCategoria: null,
            itens: [],
            itemEmFoco: null,
            subItensPorItem: {},
            selecaoItens: [],
            selecaoSubItens: []
        }
    },

    computed: {
        subItensEmFoco() {
            if (!this.itemEmFoco) {
                return []
            }
            let subItens = this.subItensPorItem[this.itemEmFoco.idItem]
            return subItens ? subItens : []
        },

        totalItensSelecionados() {
            return this.selecaoItens.length
        },

        totalSubItensSelecionados() {
            return this.selecaoSubItens.length
        },

        totalSelecionados() {
            return this.totalItensSelecionados + this.totalSubItensSelecionados
        },

        podeIntegrar() {
            return (
                this.idContrato !== null &&
                this.idCategoria !== null &&
                this.totalSelecionados > 0
            )
        },

        impedimento() {
            if (this.idContrato === null) {
                return 'Selecione o contrato'
            }
            if (this.idCategoria === null) {
                return 'Selecione a categoria MeEventos'
            }
            if (this.totalSelecionados === 0) {
                return 'Selecione ao menos um item ou subitem'
            }
            return ''
        },

        selecionados() {
            let linhas = []

            this.selecaoSubItens.forEach((subItem) => {
                linhas.push({
                    id: subItem.idSubItem,
                    tipo: 'SUBITEM',
                    item: `${subItem.ordemItem} — ${subItem.descricaoItem}`,
                    ordem: subItem.ordem,
                    descricao: subItem.descricao
                })
            })

            this.selecaoItens.forEach((item) => {
                linhas.push({
                    id: item.idItem,
                    tipo: 'ITEM',
                    item: 'Item sem subitens',
                    ordem: item.ordem,
                    descricao: item.descricao
                })
            })

            return linhas.sort((a, b) => {
                if (a.item !== b.item) {
                    return String(a.item).localeCompare(String(b.item))
                }
                return String(a.ordem).localeCompare(String(b.ordem), undefined, {
                    numeric: true
                })
            })
        }
    },

    methods: {
        obterContratos() {
            this.$store.dispatch('addRequest')
            MeEventosServicos.obterContratos().then((response) => {
                if (response) {
                    if (response.success) {
                        this.contratos = response.data ? response.data : []
                    } else {
                        this.exibirRetorno(response)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterCategorias() {
            this.$store.dispatch('addRequest')
            MeEventosServicos.obterCategorias().then((response) => {
                if (response) {
                    if (response.success) {
                        this.categorias = response.data ? response.data : []
                    } else {
                        this.exibirRetorno(response)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterItens() {
            this.$store.dispatch('addRequest')
            MeEventosServicos.obterItensContrato(this.idContrato).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.itens = response.data ? response.data : []
                        } else {
                            this.exibirRetorno(response)
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        focarItem(item) {
            this.itemEmFoco = item
            if (!item.possuiSubitens) {
                return
            }
            if (this.subItensPorItem[item.idItem]) {
                return
            }
            this.$store.dispatch('addRequest')
            MeEventosServicos.obterSubItens(this.idContrato, item.idItem).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.subItensPorItem = {
                                ...this.subItensPorItem,
                                [item.idItem]: response.data
                                    ? response.data
                                    : []
                            }
                        } else {
                            this.exibirRetorno(response)
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        alternarItem(item) {
            let indice = this.selecaoItens.findIndex((selecionado) => {
                return selecionado.idItem === item.idItem
            })
            if (indice === -1) {
                this.selecaoItens.push(item)
            } else {
                this.selecaoItens.splice(indice, 1)
            }
        },

        alternarSubItem(subItem) {
            let indice = this.selecaoSubItens.findIndex((selecionado) => {
                return selecionado.idSubItem === subItem.idSubItem
            })
            if (indice === -1) {
                this.selecaoSubItens.push(
                    this.montarSubItemSelecionado(subItem)
                )
            } else {
                this.selecaoSubItens.splice(indice, 1)
            }
        },

        marcarNaoIntegrados(naoIntegrados) {
            naoIntegrados.forEach((subItem) => {
                let selecionado = this.selecaoSubItens.some((item) => {
                    return item.idSubItem === subItem.idSubItem
                })
                if (!selecionado) {
                    this.selecaoSubItens.push(
                        this.montarSubItemSelecionado(subItem)
                    )
                }
            })
        },

        montarSubItemSelecionado(subItem) {
            return {
                idSubItem: subItem.idSubItem,
                ordem: subItem.ordem,
                descricao: subItem.descricao,
                idItem: this.itemEmFoco.idItem,
                ordemItem: this.itemEmFoco.ordem,
                descricaoItem: this.itemEmFoco.descricao
            }
        },

        remover(linha) {
            if (linha.tipo === 'ITEM') {
                let indice = this.selecaoItens.findIndex((item) => {
                    return item.idItem === linha.id
                })
                this.selecaoItens.splice(indice, 1)
            } else {
                let indice = this.selecaoSubItens.findIndex((subItem) => {
                    return subItem.idSubItem === linha.id
                })
                this.selecaoSubItens.splice(indice, 1)
            }
        },

        limpar() {
            this.selecaoItens = []
            this.selecaoSubItens = []
        },

        integrar() {
            this.retorno = null
            this.$store.dispatch('addRequest')
            MeEventosServicos.integrar(this.idContrato, {
                categoriaMeEventosId: this.idCategoria,
                itensContratosSelecionadosIds: this.selecaoItens.map((item) => {
                    return item.idItem
                }),
                subItensSelecionadosIds: this.selecaoSubItens.map((subItem) => {
                    return subItem.idSubItem
                })
            }).then((response) => {
                if (response) {
                    this.exibirRetorno(
                        response,
                        'Os itens serão integrados ao sistema da MeEventos em breve!'
                    )
                    if (response.success) {
                        this.limpar()
                        this.subItensPorItem = {}
                        this.obterItens()
                        this.$store.dispatch('setRecarregar', true)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        exibirRetorno(response, mensagemSucesso) {
            this.retorno = response.success
                ? { mensagem: mensagemSucesso, variant: 'success' }
                : { mensagem: this.obterMensagem(response), variant: 'danger' }
            this.agendarOcultarRetorno()
        },

        agendarOcultarRetorno() {
            clearTimeout(this.temporizadorRetorno)
            this.temporizadorRetorno = setTimeout(() => {
                this.retorno = null
            }, 10000)
        },

        obterMensagem(response) {
            return response.mensagem
                ? String(response.mensagem)
                : 'Não foi possível concluir a operação.'
        },

        voltar() {
            this.$router.push({ name: 'Integracoes_MeEventos' })
        }
    },

    created() {
        this.obterContratos()
        this.obterCategorias()
    },

    beforeDestroy() {
        clearTimeout(this.temporizadorRetorno)
    },

    watch: {
        idContrato() {
            this.itens = []
            this.itemEmFoco = null
            this.subItensPorItem = {}
            this.retorno = null
            this.limpar()
            if (this.idContrato) {
                this.obterItens()
            }
        }
    }
}
</script>

<style scoped>
.barra-selecao {
    position: sticky;
    bottom: 0;
}
</style>
